var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 139,
    viewBox: "0 0 139 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.474 135.932C106.178 135.932 135.932 106.178 135.932 69.474C135.932 32.77 106.178 3.01562 69.474 3.01562C32.77 3.01562 3.01562 32.77 3.01562 69.474C3.01562 106.178 32.77 135.932 69.474 135.932Z",
    fill: "#BD8600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4792 138.958C31.1671 138.958 0 107.79 0 69.4792C0 31.1686 31.1671 0 69.4792 0C107.791 0 138.958 31.1686 138.958 69.4792C138.958 107.79 107.791 138.958 69.4792 138.958ZM69.4792 6.04167C34.5006 6.04167 6.04167 34.4992 6.04167 69.4792C6.04167 104.459 34.5006 132.917 69.4792 132.917C104.458 132.917 132.917 104.459 132.917 69.4792C132.917 34.4992 104.458 6.04167 69.4792 6.04167Z",
    fill: "#F3BA2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7684 82.648C92.7684 70.7264 81.7588 67.021 72.0591 64.3862V43.9911C76.0936 44.1112 80.0891 44.8179 83.9199 46.0889L87.439 47.495L90.2614 40.4391L86.7335 39.0215C82.0089 37.3839 77.0582 36.4916 72.0591 36.3765V29.9844H66.992V36.4209C56.588 37.1733 46.2828 42.5774 46.2828 53.4856C46.2828 64.9321 57.4824 68.3474 66.992 70.8961V92.1501C61.7702 92.0322 56.6146 90.9539 51.7832 88.9692L48.3844 87.2704L44.9844 94.0692L48.3844 95.7692C48.6922 95.9225 55.605 99.3061 66.992 99.7621V108.524H72.0591V99.7393C84.7269 98.9754 92.7684 92.4363 92.7684 82.648ZM53.8784 53.4856C53.8784 46.9832 61.4284 44.5979 66.987 44.0532V63.0104C58.7732 60.6948 53.8835 58.5311 53.8835 53.4856H53.8784ZM72.0591 92.1108V72.2858C80.2932 74.6698 85.1677 77.0501 85.1677 82.648C85.1677 90.0003 76.9654 91.732 72.0591 92.1108Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiat);
export default __webpack_public_path__ + "static/media/fiat.c083da071ef533f8f3dce478735efa17.svg";
export { ForwardRef as ReactComponent };